<template>
  <v-snackbar
    transition="scale-transition"
    v-model="snackbar"
    :timeout="3000"
    :value="true"
    centered
    top
    :color="type"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  computed: {
    type() {
      return this.$store.state.snackbar ? this.$store.state.snackbar.type : null;
    },
    message() {
      return this.$store.state.snackbar ? this.$store.state.snackbar.message : null;
    },
    snackbar: {
      get() {
        return this.type && this.message;
      },
      set() {
        return this.type && this.message;
      },
    },
  },
};
</script>

<style scoped>

</style>
